import * as React from 'react';

const PlusFooter = ({
  fill = '#4A4F4A',
  width = '24',
  height = '24'
}: React.SVGProps<SVGSVGElement>) => (
  <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M9.3 0.5H8V8.5H0V9.8H8V17.5H9.3V9.8H17V8.5H9.3V0.5Z" fill="#EAEAEA" />
  </svg>
);

export default PlusFooter;
